<template>
  <span class="field-label" :class="{ 'field-label--has-icon': Boolean($attrs.icon) }">
    <label class="elder-input__label" v-html="content"></label>
    <span class="field-label__icon"><Icon v-if="$attrs.icon" :icon="$attrs.icon" size="1x" /></span>
  </span>
</template>

<script>
import Icon from '@kvass/vue2-icon'
export default {
  props: ['value'],
  computed: {
    content() {
      if (this.value && typeof this.value === 'string') return this.value
      if (this.value && this.value.content) return this.value.content
      return this.$attrs.label
    },
  },
  components: {
    Icon,
  },
}
</script>

<style lang="scss">
.field-label {
  &--has-icon {
    display: flex;
    gap: 0.5rem;
    align-items: center;
    margin-bottom: -25px;
    h3 {
      margin: 0;
    }
  }
  &__icon {
    position: relative;
    height: 30px;
    width: 30px;

    background-color: var(--secondary);
  }
  svg {
    padding: 1px;
    top: 50%;
    transform: translate(-50%, -50%);
    left: 50%;

    position: absolute;
  }
}
</style>
